<template>
  <div class="bank-id-success">
    <Container>
      <Card padding="large">
        <b-row v-if="isLoading" align-h="center">
          <b-col cols="auto">
            <Loader class="margins__double" :text="$t('LOADING')" />
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12" sm="auto" class="text-center">
            <SuccessSVG class="icon h1 text-white" />
          </b-col>
          <b-col>
            <Margins>
              <h1 class="h3 text-normal">{{ $t('ORDER_COMPLETE') }}</h1>
              <template>
                <p class="text-small">
                  {{ $t('ORDER_COMPLETE_INFO') }}
                </p>
                <p class="text-small">{{ $t('ORDER_COMPLETE_INFO_2') }}</p>

                <Separator size="large" />
                <div class="text-center">
                  <Button @click="$router.push({ name: ROUTES.HOME.name })">{{
                    $t('MAKE_NEW_ORDER')
                  }}</Button>
                </div>
              </template>
            </Margins>
          </b-col>
        </b-row>
      </Card>
    </Container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  Button,
  Card,
  Container,
  Loader,
  Margins,
  Separator,
} from '@/components';
import SuccessSVG from '@/assets/images/success.svg';
import { constants } from '@/mixins';

export default {
  name: 'Success',
  mixins: [constants],
  components: {
    Container,
    Card,
    Margins,
    Button,
    Separator,
    Loader,
    SuccessSVG,
  },
  data() {
    return {
      refreshTimer: null,
    };
  },
  async mounted() {
    this.refreshTimer = setTimeout(() => {
      this.$router.push({ name: this.ROUTES.HOME.name });
    }, 60000);
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
  },
  computed: {
    ...mapState(['isLoading']),
  },
};
</script>
